import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { WHATSAPP_URL } from "@/data/constants";

const NAV_LINKS = [
{ label: "Home", path: "/" },
{ label: "Fees & Pricing", path: "/consultations" },
{ label: "Process & Policies", path: "/process" },
{ label: "Verify Authenticity", path: "/verify" },
{ label: "Contact", path: "/contact" }];


export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {setMobileOpen(false);}, [location]);

  return (
    <nav
      data-testid="navbar"
      style={{
        backgroundColor: scrolled ? "rgba(253,252,248,0.95)" : "#FDFCF8",
        borderBottom: "1px solid #E5E0D8",
        backdropFilter: scrolled ? "blur(12px)" : "none",
        transition: "all 0.3s ease"
      }}
      className="sticky top-0 z-50">

      <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-16">
        <div className="flex items-center justify-between h-16 sm:h-20">
          {/* Logo */}
          <Link to="/" data-testid="nav-logo" className="flex flex-col leading-tight">
            <span style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: "1.4rem", fontWeight: 500, color: "#1A1A1A", letterSpacing: "0.02em" }}>
              Akkshay Narula
            </span>
            <span style={{ fontSize: "0.6rem", letterSpacing: "0.18em", color: "#B89047", textTransform: "uppercase", fontFamily: "'Outfit', sans-serif" }} className="!text-[#B89047]">Astrologer · Author · Vastu Consultant · Numerologist · Astrocartographer

            </span>
          </Link>

          {/* Desktop Links */}
          <div className="hidden lg:flex items-center gap-8">
            {NAV_LINKS.map((link) =>
            <Link
              key={link.path}
              to={link.path}
              data-testid={`nav-link-${link.label.toLowerCase().replace(/\s+/g, "-")}`}
              style={{
                fontSize: "0.7rem",
                letterSpacing: "0.15em",
                textTransform: "uppercase",
                color: location.pathname === link.path ? "#B89047" : "#1A1A1A",
                fontFamily: "'Outfit', sans-serif",
                fontWeight: 500,
                transition: "color 0.2s",
                textDecoration: "none"
              }}
              onMouseEnter={(e) => {e.target.style.color = "#B89047";}}
              onMouseLeave={(e) => {e.target.style.color = location.pathname === link.path ? "#B89047" : "#1A1A1A";}}>

                {link.label}
              </Link>
            )}
          </div>

          {/* WhatsApp CTA */}
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-whatsapp-btn"
            className="hidden lg:flex items-center gap-2"
            style={{
              backgroundColor: "#1A1A1A",
              color: "#FDFCF8",
              padding: "10px 20px",
              fontSize: "0.7rem",
              letterSpacing: "0.12em",
              textTransform: "uppercase",
              fontFamily: "'Outfit', sans-serif",
              fontWeight: 500,
              textDecoration: "none",
              transition: "background-color 0.3s"
            }}
            onMouseEnter={(e) => {e.currentTarget.style.backgroundColor = "#B89047";}}
            onMouseLeave={(e) => {e.currentTarget.style.backgroundColor = "#1A1A1A";}}>

            Book Consultation
          </a>

          {/* Mobile Menu Toggle */}
          <button
            data-testid="mobile-menu-toggle"
            onClick={() => setMobileOpen(!mobileOpen)}
            className="lg:hidden p-2"
            style={{ color: "#1A1A1A" }}>

            {mobileOpen ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileOpen &&
      <div style={{ backgroundColor: "#FDFCF8", borderTop: "1px solid #E5E0D8" }} className="lg:hidden">
          <div className="px-6 py-6 flex flex-col gap-5">
            {NAV_LINKS.map((link) =>
          <Link
            key={link.path}
            to={link.path}
            data-testid={`mobile-nav-${link.label.toLowerCase().replace(/\s+/g, "-")}`}
            style={{
              fontSize: "0.75rem",
              letterSpacing: "0.15em",
              textTransform: "uppercase",
              color: location.pathname === link.path ? "#B89047" : "#1A1A1A",
              fontFamily: "'Outfit', sans-serif",
              fontWeight: 500,
              textDecoration: "none"
            }}>

                {link.label}
              </Link>
          )}
            <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="mobile-whatsapp-btn"
            style={{
              backgroundColor: "#1A1A1A",
              color: "#FDFCF8",
              padding: "12px 20px",
              fontSize: "0.75rem",
              letterSpacing: "0.12em",
              textTransform: "uppercase",
              fontFamily: "'Outfit', sans-serif",
              fontWeight: 500,
              textDecoration: "none",
              textAlign: "center",
              marginTop: "8px"
            }}>

              Book via WhatsApp
            </a>
          </div>
        </div>
      }
    </nav>);

}